import { CSSObject } from '@emotion/react'

const indexIndicatorContainer: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  position: 'relative',
  bottom: '20px',
}

const indexIndicatorStyles = (isActive: boolean): CSSObject => ({
  height: '6px',
  width: '6px',
  borderRadius: '100%',
  backgroundColor: isActive ? '#0098fd' : '#dbdbdb',
  margin: '0 2.5px',
})

const indexIndicatorStylesMedium: CSSObject = {
  height: '4px',
  width: '4px',
  borderRadius: '100%',
  backgroundColor: '#dbdbdb',
  margin: '0 3px',
}

const indexIndicatorStylesSmall: CSSObject = {
  height: '2px',
  width: '2px',
  borderRadius: '100%',
  backgroundColor: '#dbdbdb',
  margin: '0 4px',
}

export const styles = {
  indexIndicatorContainer,
  indexIndicatorStyles,
  indexIndicatorStylesSmall,
  indexIndicatorStylesMedium,
}
